export const GET_MESSAGE_GROUPS = 'GET_MESSAGE_GROUPS';
export const GET_MESSAGE_GROUP = 'GET_MESSAGE_GROUP';
export const REMOVE_MESSAGE_GROUP = 'REMOVE_MESSAGE_GROUP';
export const FILTER_MESSAGE_GROUP = 'FILTER_MESSAGE_GROUP';
export const ADD_MESSAGE_GROUP = 'ADD_MESSAGE_GROUP';
export const UPDATE_MESSAGE_GROUP = 'UPDATE_MESSAGE_GROUP';
export const MESSAGE_GROUP_ERROR = 'MESSAGE_GROUP_ERROR';
